/* eslint-disable @typescript-eslint/naming-convention */

import { DotNetFormulaErrorCodesEnum } from './dotnet-formula-error-codes.enum';

export interface DotNetFormulaResultModel {
	isSuccess: boolean;
	result: number;
	stringResult: string;
	errorCode: DotNetFormulaErrorCodesEnum | null;
	errorMessage: string | null;
}
